import React from 'react';
import { ArrowRight, Star, Sparkles } from 'lucide-react';

const CTA = () => {
  return (
    <section className="relative py-24 md:py-32 bg-ink text-paper overflow-hidden">
      {/* dot grid bg in lime, very faint */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, #C8FA3D 1px, transparent 0)',
          backgroundSize: '22px 22px',
        }}
      />

      <div className="frame relative z-10">
        {/* Masthead */}
        <div className="flex items-center justify-between pb-6 border-b border-paper/30">
          <div className="flex items-center gap-3">
            <span className="chip-lime inline-flex items-center gap-1.5">
              <Star className="w-3 h-3" strokeWidth={2} />
              Limited Time Offer
              <Star className="w-3 h-3" strokeWidth={2} />
            </span>
          </div>
          <span className="font-mono text-micro uppercase tracking-label text-paper/70 hidden sm:inline">
            07 / Get Started
          </span>
        </div>

        {/* Composition */}
        <div className="mt-12 md:mt-16 grid grid-cols-12 gap-x-6 lg:gap-x-10 gap-y-12">
          <div className="col-span-12 lg:col-span-8">
            <h2
              className="font-display font-semibold tracking-[-0.02em] text-paper leading-[0.95]"
              style={{ fontSize: 'clamp(2.5rem, 7vw, 6.5rem)' }}
            >
              Ready to Build<br/>
              Something <span className="hl-lime !text-ink">Amazing?</span>
            </h2>

            <p className="mt-8 max-w-measure text-paper/80 text-lg leading-relaxed">
              Get a free consultation and project estimate. Our experts will help
              you choose the right technology and approach for your specific needs.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-3">
              <button
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                className="btn-lime"
              >
                <span>Get Started Now</span>
                <ArrowRight className="w-4 h-4" strokeWidth={2} />
              </button>
              <a href="mailto:support@charliecollc.com" className="btn-ghost-light">
                <span>Email Us Directly</span>
              </a>
            </div>

            {/* Trust indicators */}
            <div className="mt-10 pt-6 border-t border-paper/30">
              <p className="font-mono text-[12px] text-paper/70 uppercase tracking-label">
                Trusted by <span className="text-lime">200+ companies</span> worldwide
                <span className="mx-3 text-paper/30">●</span>
                <span className="text-lime">99% client satisfaction</span>
                <span className="mx-3 text-paper/30">●</span>
                <span className="text-lime">10+ years of excellence</span>
              </p>
            </div>
          </div>

          {/* Side ledger — benefits */}
          <aside className="col-span-12 lg:col-span-4 lg:pl-10 lg:border-l border-paper/30">
            <ul className="space-y-7">
              <li>
                <div className="flex items-center gap-2 font-mono text-micro uppercase tracking-label text-lime">
                  <Sparkles className="w-3.5 h-3.5" strokeWidth={1.5} /> 01
                </div>
                <div className="mt-1 font-display font-semibold text-2xl tracking-tight text-paper">
                  Free Consultation
                </div>
              </li>
              <li>
                <div className="flex items-center gap-2 font-mono text-micro uppercase tracking-label text-lime">
                  <Sparkles className="w-3.5 h-3.5" strokeWidth={1.5} /> 02
                </div>
                <div className="mt-1 font-display font-semibold text-2xl tracking-tight text-paper">
                  No Obligation
                </div>
              </li>
              <li>
                <div className="flex items-center gap-2 font-mono text-micro uppercase tracking-label text-lime">
                  <Sparkles className="w-3.5 h-3.5" strokeWidth={1.5} /> 03
                </div>
                <div className="mt-1 font-display font-semibold text-2xl tracking-tight text-paper">
                  Expert Guidance
                </div>
              </li>
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default CTA;
